import React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { Creator } from '../types/socialGlass';
import PlatformLogo from '../components/PlatformLogo';
import { UI_CONSTANTS } from '../constants/uiConstants';

interface TopCreatorsSectionProps {
  creators: Creator[];
  selectedCreator: Creator | null;
  onCreatorSelect: (creator: Creator) => void;
  showAllCreators: boolean;
  onToggleShowAll: () => void;
  isCreatorSelected: (creator: Creator) => boolean;
}

const TopCreatorsSection: React.FC<TopCreatorsSectionProps> = ({
  creators,
  selectedCreator,
  onCreatorSelect,
  showAllCreators,
  onToggleShowAll,
  isCreatorSelected,
}) => {
  return (
    <div>
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-2xl font-bold">Top Creators</h2>
        <button
          onClick={onToggleShowAll}
          className="text-sm font-medium text-[#DB4225] hover:underline"
        >
          {showAllCreators ? "Show Less" : "See More"}
        </button>
      </div>

      {showAllCreators ? (
        <div className="grid grid-cols-4 gap-4">
          {creators.map((creator, idx) => {
            const selected = isCreatorSelected(creator);
            return (
              <button
                key={idx}
                onClick={() => onCreatorSelect(creator)}
                className={`flex min-w-[276px] max-w-[320px] flex-col gap-0 rounded-xl border-none px-4 py-1 text-left shadow-[0_4px_12px_rgba(0,0,0,0.05),0_-0px_16px_rgba(0,0,0,0.05)] transition-all duration-150 focus:outline-none ${
                  selected ? UI_CONSTANTS.COLORS.PRIMARY_BG : "bg-white"
                }`}
              >
                <div className="flex items-center gap-2">
                  <img
                    src={creator.avatar}
                    alt={creator.name}
                    className="h-16 w-16 rounded-full"
                  />
                  <div className="flex flex-1 flex-col overflow-hidden">
                    <div className="truncate text-[16px] font-normal text-black">
                      {creator.name}
                    </div>
                    <div className="truncate text-[14px] text-gray-500">
                      @{creator.name}
                    </div>
                  </div>
                  <div className="flex h-6 w-6 shrink-0 items-center justify-center">
                    <PlatformLogo platform={creator.platform} />
                  </div>
                </div>

                <div className="mx-2 mt-0 flex gap-10 text-[14px] text-gray-600">
                  <div className="flex flex-col">
                    <span>Followers</span>
                    <span className="font-normal text-black">
                      {creator.followers}
                    </span>
                  </div>
                  {creator.platform === "tiktok" && (
                    <div className="flex flex-col">
                      <span>Likes</span>
                      <span className="font-normal text-black">
                        {creator.likes}
                      </span>
                    </div>
                  )}
                </div>

                <div className="mx-2 mt-2 text-[14px] text-[#DB4225]">
                  {creator.mentions} Mentions
                </div>
              </button>
            );
          })}
        </div>
      ) : (
        <ScrollContainer className="hide-scrollbar flex cursor-grab gap-3 overflow-x-auto pb-2 pt-2 active:cursor-grabbing">
          {creators.map((creator, idx) => {
            const selected = isCreatorSelected(creator);
            return (
              <button
                key={idx}
                onClick={() => onCreatorSelect(creator)}
                className={`flex min-w-[276px] max-w-[320px] flex-col gap-0 rounded-xl border-none px-4 py-1 text-left shadow-[0_4px_12px_rgba(0,0,0,0.05),0_-0px_16px_rgba(0,0,0,0.05)] transition-all duration-150 focus:outline-none ${
                  selected ? UI_CONSTANTS.COLORS.PRIMARY_BG : "bg-white"
                }`}
              >
                <div className="flex items-center gap-2">
                  <img
                    src={creator.avatar}
                    alt={creator.name}
                    className="h-16 w-16 rounded-full"
                  />
                  <div className="flex flex-1 flex-col overflow-hidden">
                    <div className="truncate text-[16px] font-normal text-black">
                      {creator.name}
                    </div>
                    <div className="truncate text-[14px] text-gray-500">
                      @{creator.name}
                    </div>
                  </div>
                  <div className="flex h-6 w-6 shrink-0 items-center justify-center">
                    <PlatformLogo platform={creator.platform} />
                  </div>
                </div>

                <div className="mx-2 mt-0 flex gap-10 text-[14px] text-gray-600">
                  <div className="flex flex-col">
                    <span>Followers</span>
                    <span className="font-normal text-black">
                      {creator.followers}
                    </span>
                  </div>
                  {creator.platform === "tiktok" && (
                    <div className="flex flex-col">
                      <span>Likes</span>
                      <span className="font-normal text-black">
                        {creator.likes}
                      </span>
                    </div>
                  )}
                </div>

                <div className="mx-2 mt-2 text-[14px] text-[#DB4225]">
                  {creator.mentions} Mentions
                </div>
              </button>
            );
          })}
        </ScrollContainer>
      )}
    </div>
  );
};

export default TopCreatorsSection;
